import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import {
  MatPaginator, MatTableDataSource,
  MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSort
} from '@angular/material';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import { DataSource } from '@angular/cdk/collections';

import { DatePipe } from '@angular/common';
import { TokenStorage } from 'src/app/auth/token.storage';
import { AllorderdetailsComponent } from '../order/allorderdetails/allorderdetails.component';
import { OrderService } from 'src/app/services/order/order.service';

@Component({
  selector: 'app-pickups',
  templateUrl: './pickups.component.html',
  styleUrls: ['./pickups.component.scss']
})
export class PickupsComponent implements OnInit {

  columnsToDisplay = [
    'invoice',
    'zone',
    'deliveryBoy',
    'department',
    'deliveryEta',
    'origin',
    'receiver',
    'destination',
    'packageDetails',
    'numOfItems',
  ];
  orderDataArray = new MatTableDataSource();
  unplannedCount: number = 0;
  inPlanningCount: number = 0;
  scheduledCount: number = 0;
  intransitCount: number = 0;
  failedCount: number = 0;
  deliveredCount: number = 0;
  filter: string = 'date';
  ordersArray = [];
  selectedVal: string;
  mapView: boolean = false;
  @Output() notifyParent: EventEmitter<any> = new EventEmitter();
  page: number = 0;
  totalRecords: number;
  typeOfOrder: string;
  isZoneOfOriginAddress: boolean = false;
  fromDate: any;
  toDate: any;
  isLoading: boolean = false;
  isTenantDiag: boolean = false;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @Input() data: string;
  constructor(public dialog: MatDialog,
    public orderService: OrderService,
    public datePipe: DatePipe,
    private token: TokenStorage
  ) {

    this.getNotification('evt');
  }


  ngOnInit() {

    if (this.token.getCustomerType() === 'Diagnostic') {
      this.isTenantDiag = true;
      this.selectedVal = '0';
    } else {
      this.isTenantDiag = false;
      this.selectedVal = '7';
    }  

    this.typeOfOrder = 'ORDER_STATE_UNPLANNED';
    this.findOrders(this.selectedVal);
    this.orderDataArray.sortingDataAccessor = (item: any, property) => {
      switch (property) {
        case 'receiver': return item.orderInfo.receiverName;
        case 'zone': return item.orderInfo.destinationAddress.zone || item.orderInfo.originAddress.zone;
        case 'deliveryEta': return item.orderInfo.deliveryETADateTime;
      }
    };
    this.orderDataArray.sort = this.sort;


  }
  onValChange(e) {
    this.notifyParent.emit('e');
  }

  getNotification(evt) {
    //alert(evt);
  }

  searchArraryForCount(arr, value) {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].orderstatus === value) {
        return arr[i];
      }
    }
  }

  filterList() {
    console.log(this.filter);
    if (this.filter === "week") {

    }
    console.log(this.ordersArray);
  }

  orderData(type) {
    //console.log(type);
    this.page = 0;
    this.paginator._pageIndex = 0;
    switch (type) {

      case "unplanned":
        this.orderDataArray.data = [];
        this.typeOfOrder = 'ORDER_STATE_UNPLANNED';
        this.getOrdersData();
        break;
      case "inplanning":
        this.typeOfOrder = 'ORDER_STATE_IN_PLANNING';
        this.getOrdersData();
        break;
      case "scheduled":
        this.typeOfOrder = 'ORDER_STATE_SCHEDULED';
        this.getOrdersData();
        break;
      case "intransit":
        this.typeOfOrder = 'ORDER_STATE_IN_TRANSIT';
        this.getOrdersData();
        break;
      case "failed":
        this.typeOfOrder = 'ORDER_STATE_FAILED';
        this.getOrdersData();
        break;
      case "delivered":
        this.typeOfOrder = 'ORDER_STATE_DELIVERED';
        this.getOrdersData();
        break;
      default:
        this.typeOfOrder = 'ORDER_STATE_UNPLANNED';
        this.getOrdersData();
    }
  }

  getOrdersData() {
    this.isLoading = true;
    this.orderDataArray.data = [];
    this.getData(this.typeOfOrder, this.fromDate, this.toDate).subscribe(res => {
      this.isLoading = false;
      this.calculateNumOfItemsInOrder(res);
      this.orderDataArray.data = res.content;
      this.ordersArray = res.content;
      this.totalRecords = res.totalElements;
    });
  }

  getData(type, from, to) {

    if (type == 'ORDER_STATE_SCHEDULED')
      type = ['ORDER_STATE_SCHEDULED', 'ORDER_STATE_SCHEDULED_FOR_PICKUP']

    if (this.isTenantDiag) {
      let oTypes = 'ORDER_TYPE_PICKUP'
      return this.orderService.getAllOrdersByTypesAndOTypesDateRange(type, oTypes, this.page, from, to, 'nozone');
    }
    else {
      return this.orderService.getAllOrdersByTypesDateRange(type, this.page, from, to, 'nozone');
    }

  }

  pageChanged(event) {
    this.page = event.pageIndex;
    this.getOrdersData();
  }

  orderDetails(data) {
    let editDialog = this.dialog.open(AllorderdetailsComponent, {
      width: '800px',
      data: {
        data: data,
        component: 'pickup'
      }
    });
    editDialog.updatePosition({
      top: '50px', right: '0px',
    });
  }

  MapVIewSingle() {
    alert("mapiew");
  }

  findOrders(days) {
    this.isLoading = true;
    this.orderDataArray.data = [];
    let date, last, day, month, year;
    date = new Date();
    last = new Date(date.getTime() - (days * 24 * 60 * 60 * 1000));
    day = last.getDate();
    month = last.getMonth();
    year = last.getFullYear();
    this.fromDate = this.datePipe.transform(new Date(year, month, day), 'yyyy-MM-dd');
    this.toDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    this.getData(this.typeOfOrder, this.fromDate, this.toDate).subscribe(orders => {
      this.isLoading = false;
      this.calculateNumOfItemsInOrder(orders);
      this.orderDataArray.data = orders.content;
      this.totalRecords = orders.totalElements;
      if (this.orderDataArray.data.length === 0) {
        this.totalRecords = 0;
        this.page = 0;
        this.paginator._pageIndex = 0;
      }
      console.log("Orders", orders);
      this.getOrderCountByStatus();
    });
  }

  getOrderCountByStatus() {
    this.orderService.getOrderCountByStatus(this.fromDate, this.toDate, []).subscribe(res => {
      console.log("order count by status", res);
      if (res.length != 0) {
        if (this.searchArraryForCount(res, 'ORDER_STATE_UNPLANNED') != undefined) {
          this.unplannedCount = this.searchArraryForCount(res, 'ORDER_STATE_UNPLANNED').ordercount;
        }
        if (this.searchArraryForCount(res, 'ORDER_STATE_IN_PLANNING') != undefined) {
          this.inPlanningCount = this.searchArraryForCount(res, 'ORDER_STATE_IN_PLANNING').ordercount;
        }

        if (this.searchArraryForCount(res, 'ORDER_STATE_SCHEDULED') != undefined) {
          this.scheduledCount = this.searchArraryForCount(res, 'ORDER_STATE_SCHEDULED').ordercount;
        }

        if (this.searchArraryForCount(res, 'ORDER_STATE_IN_TRANSIT') != undefined) {
          this.intransitCount = this.searchArraryForCount(res, 'ORDER_STATE_IN_TRANSIT').ordercount;
        }

        if (this.searchArraryForCount(res, 'ORDER_STATE_FAILED') != undefined) {
          this.failedCount = this.searchArraryForCount(res, 'ORDER_STATE_FAILED').ordercount;
        }

        if (this.searchArraryForCount(res, 'ORDER_STATE_DELIVERED') != undefined) {
          this.deliveredCount = this.searchArraryForCount(res, 'ORDER_STATE_DELIVERED').ordercount;
        }
      }
      else {
        this.unplannedCount = 0;
        this.inPlanningCount = 0;
        this.scheduledCount = 0;
        this.intransitCount = 0;
        this.failedCount = 0;
        this.deliveredCount = 0;
      }
    });
  }

  calculateNumOfItemsInOrder(orderArray) {
    console.log(orderArray)
    orderArray.content.forEach(function (order) {
      let numOfItemsInOrder = 0;
      order.prodQList.forEach(function (prod) {
        numOfItemsInOrder = numOfItemsInOrder + prod.productQuantity;
      });
      order.numOfItemsInOrder = numOfItemsInOrder
    });
  }


}

export interface OrderListElement {
  zone: string,
  receiver: string,
  orderInvoiceNumber: string,
  deliveryETADate: string,
  packageDetails: string,
  originAddress: string,
  destinationAddress: string,
  numOfItems: string,
  action: string
}
